import {Component} from 'react';

import {CommentsEventLogger} from '../../../services/analytics/comments';

class CommentsModalErrorBoundary extends Component {
  componentDidCatch(error) {
    if (window.history.state?.id) {
      CommentsEventLogger.openFromCommentsButtonError(error.toString(), this.props.articleId);
    } else {
      CommentsEventLogger.openFromUrlError(error.toString(), this.props.articleId);
    }
  }

  render() {
    return this.props.children;
  }
}

export {CommentsModalErrorBoundary};
